import React, { useEffect } from "react";

import { DataBoxGroup } from "@transfr-inc/dashboard-components";

import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

const ChartFilter = {
  ActiveExplorers: {
    key: "totalActiveUsers",
    label: `Unique ${getLearnerTerm({ plural: true })}`,
  },
  ExploredVR: {
    key: "totalVRSimsExplored",
    label: "Explored VR",
  },
  CareersExplored: {
    key: "totalCareersExplored",
    label: "Careers Explored",
  },
  BudgetsCompleted: {
    key: "totalBudgetPlansCompleted",
    label: "Budgets Created",
  },
  CareersSelected: {
    key: "totalPlansSubmitted",
    label: "Careers Selected",
  },
};

export function TrekDataboxes({ data, onCategoryChange }) {
  const dataBoxConfig = [
    {
      label: ChartFilter.ActiveExplorers.label,
      key: ChartFilter.ActiveExplorers.key,
      alt: "Icon for a user avatar wearing a hardhat.",
      description: `${getLearnerTerm({
        plural: true,
      })} who have logged into Trek and completed the Interest Inventory`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.ActiveExplorers),
    },
    {
      label: ChartFilter.ExploredVR.label,
      key: ChartFilter.ExploredVR.key,
      alt: "Icon for a user wearing a VR headset.",
      description: `Number of careers ${getLearnerTerm({
        lowercase: true,
        plural: true,
      })} have completed in VR.`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.ExploredVR),
    },
    {
      label: ChartFilter.BudgetsCompleted.label,
      key: ChartFilter.BudgetsCompleted.key,
      alt: "Icon for a checkmark within a circle.",
      description: `Number of budgets ${getLearnerTerm({
        lowercase: true,
        plural: true,
      })} have created`,
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.BudgetsCompleted),
    },
    {
      label: ChartFilter.CareersSelected.label,
      key: ChartFilter.CareersSelected.key,
      alt: "Icon for a medal.",
      description: "Number of submitted career plans",
      className: "data-box",
      onClick: () => onCategoryChange(ChartFilter.CareersSelected),
    },
  ];

  useEffect(() => {
    dataBoxConfig[0].onClick();
  }, []);

  return (
    <DataBoxGroup data={data} dataBoxConfig={dataBoxConfig} className="rows" />
  );
}
